import React, { PureComponent } from "react";

export default class TopbarNav extends PureComponent {
    render() {
        return <nav className="topbar__nav">{this.props.children}</nav>;
    }
}
